import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-muted text-sm text-left select-none mb-10" }

import { useI18n } from "vue-i18n";
import { computed, ref } from "vue";
import TextInput from "@/components/inputs/TextInput.vue";
import ConfirmButton from "@/views/Auth/components/ConfirmButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ForgotPasswordModalContent',
  props: {
    waitApiCall: { type: Boolean }
  },
  emits: ["forgotPassword"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit;

const { t } = useI18n();

const email = ref<string>("");

const isCredentialsValid = computed(() => {
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRe.test(email.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TextInput, {
      label: _unref(t)('auth.email'),
      modelValue: email.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
      type: "email",
      class: "mb-4"
    }, null, 8, ["label", "modelValue"]),
    _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)("auth.forgot-password-tip")), 1),
    _createVNode(ConfirmButton, {
      disabled: !isCredentialsValid.value || __props.waitApiCall,
      loading: __props.waitApiCall,
      "button-text": _unref(t)('buttons.auth.send-email'),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('forgotPassword', email.value)))
    }, null, 8, ["disabled", "loading", "button-text"])
  ], 64))
}
}

})